// extracted by mini-css-extract-plugin
export default {"background":"button-editor_background__595+C"};